import { getCookie, removeCookie } from "./cookie";

/**
 * The only code that still touches the old JavaScript-readable `token`
 * cookie (sellsmart-api#4626, ADR-5). A session signed in before this
 * release is migrated once: restoreSession() sends this token as the bearer,
 * the API answers with the HttpOnly refresh cookie, and the old cookie is
 * deleted.
 */
export const readLegacyToken = (): string | null => {
  const token = getCookie("token");
  return typeof token === "string" && token !== "" ? token : null;
};

export const clearLegacyToken = (): void => {
  removeCookie("token");
};
